import { IntlShape } from 'react-intl'

export const getSponsoredChallengeTypeName = (challengeType: string, intl: IntlShape): string =>
  intl.formatMessage({ id: `challengeType.${challengeType}` })
